import React, { useState } from 'react';
import Modal from './Modal';
import { toast } from 'react-toastify';
import api from '../utils/api';

const ADJUSTMENT_TYPES = {
    DETENTION: 'detention',
    CANCELLATION: 'cancellation', 
    ADDITIONAL_STOP: 'additional_stop',
    LAYOVER: 'layover',
    LUMPER: 'lumper',
    TOLL: 'toll',
    FUEL_SURCHARGE: 'fuel_surcharge',
    TONU: 'tonu',
    OTHER: 'other'
};

const AddChargeModal = ({ isOpen, onClose, paymentId, onChargeAdded }) => {
  const [formData, setFormData] = useState({
    type: '',
    amount: '',
    description: '',
    evidence: {}
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post(`/api/billings/${paymentId}/adjustments`, {
        ...formData,
        amount: parseFloat(formData.amount),
        evidence: {
          added_by: "system_admin",
          timestamp: new Date().toISOString(),
          notes: formData.description
        }
      });

      toast.success('Charge added successfully');
      onChargeAdded(response.data);
      onClose();
      setFormData({ type: '', amount: '', description: '', evidence: {} });
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to add charge');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Add Charge">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Charge Type
          </label>
          <select
            value={formData.type}
            onChange={(e) => setFormData({ ...formData, type: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            required
          >
            <option value="">Select a type</option>
            {Object.entries(ADJUSTMENT_TYPES).map(([key, value]) => (
              <option key={value} value={value}>
                {key.charAt(0) + key.slice(1).toLowerCase().replace('_', ' ')}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Amount ($)
          </label>
          <input
            type="number"
            step="0.01"
            value={formData.amount}
            onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Description
          </label>
          <textarea
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            rows={3}
            required
          />
        </div>

        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
          >
            {loading ? 'Adding...' : 'Add Charge'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddChargeModal; 